
/* **************************** */
/*  Lightbox                    */
/* **************************** */
$(document).ready(function() {

    $('.fancybox-media').not('.cycle-sentinel').fancybox({
        // Animation duration in ms
        speed: 330,

        // Enable infinite gallery navigation
        loop: true,

        // Should zoom animation change opacity, too
        // If opacity is 'auto', then fade-out if image and thumbnail have different aspect ratios
        opacity: 'auto',

        // Space around image, ignored if zoomed-in or viewport smaller than 800px
        margin: [94, 94],

        // Horizontal space between slides
        gutter: 90,

        // Should display toolbars
        infobar: true,
        buttons: true,

        // What buttons should appear in the toolbar
        slideShow: false,
        fullScreen: false,
        thumbs: false,
        closeBtn: true,


        // Should apply small close button at top right corner of the content
        // If 'auto' - will be set for content having type 'html', 'inline' or 'ajax'
        smallBtn: 'auto',
    });

    $.fancybox.defaults.hash = false;


});